module.exports = __webpack_public_path__ + "static/media/icon_edit_modal.7727a5b3.svg";